"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrTextBlock = void 0;
const react_1 = __importDefault(require("react"));
const fdr_text_block_styles_1 = require("./fdr-text-block.styles");
const FdrTextBlock = ({ id, title, text, className, }) => {
    return (react_1.default.createElement(fdr_text_block_styles_1.TextBlockWrapper, { className: className, "data-id": "text-block-wrapper" },
        title ? (react_1.default.createElement("h1", { className: "text-block-title", dangerouslySetInnerHTML: { __html: title } })) : null,
        react_1.default.createElement("div", { id: id, className: "text-block-text", dangerouslySetInnerHTML: { __html: text } })));
};
exports.FdrTextBlock = FdrTextBlock;
//# sourceMappingURL=fdr-text-block.js.map